(function () {
  'use strict';

  var cfg = window.CPHandlingFee;
  if (!cfg || !cfg.enabled || !cfg.variantId) return;

  if (window._cpHFInit) return;
  window._cpHFInit = true;

  var VARIANT_ID = cfg.variantId;

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }).then(function (r) { return r.json(); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function fireCartEvents(cart) {
    var detail = {
      resource: cart,
      cartData: cart,
      data: { itemCount: cart.item_count },
    };
    document.dispatchEvent(new CustomEvent('cart:update', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:count:update', { detail: { item_count: cart.item_count, total_price: cart.total_price } }));
    document.dispatchEvent(new CustomEvent('cart:drawer:render', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:reload', { detail: detail }));
  }

  var _syncing = false;
  var _ownUpdate = false;

  function sync() {
    if (_syncing) return;
    _syncing = true;

    fetchCart()
      .then(function (cart) {
        var items = cart.items || [];
        var feeItem = null;
        var otherCount = 0;

        items.forEach(function (it) {
          if (it.variant_id === VARIANT_ID) {
            feeItem = it;
          } else {
            otherCount++;
          }
        });

        if (otherCount > 0 && !feeItem) {
          return postJSON('/cart/add.js', {
            items: [{
              id: VARIANT_ID,
              quantity: 1,
              properties: { _is_handling_fee: 'true' },
            }],
          }).then(function () {
            return fetchCart();
          }).then(function (updated) {
            _ownUpdate = true;
            fireCartEvents(updated);
          });

        } else if (otherCount === 0 && feeItem) {
          return postJSON('/cart/change.js', {
            id: feeItem.key,
            quantity: 0,
          }).then(function () {
            return fetchCart();
          }).then(function (updated) {
            _ownUpdate = true;
            fireCartEvents(updated);
          });
        }
      })
      .catch(function (e) {
        if (typeof console !== 'undefined') console.warn('[handling-fee]', e);
      })
      .finally(function () {
        _syncing = false;
        setTimeout(function () { _ownUpdate = false; }, 300);
      });
  }

  var _timer;
  function debouncedSync(ms) {
    clearTimeout(_timer);
    _timer = setTimeout(sync, ms || 350);
  }

  ['cart:update', 'cart:drawer:render', 'cart:reload'].forEach(function (name) {
    document.addEventListener(name, function () {
      if (_ownUpdate) return;
      debouncedSync(350);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { debouncedSync(150); });
  } else {
    debouncedSync(150);
  }

})();
